module.exports = __webpack_public_path__ + "media/images/favicon-61fd597c1433cad110fb819f1ed8d128.ico";